import { CaseGranulometry } from '../../../CaseGranulometry';
import { Surface } from '../../../../../specification/Surface';
import { getCaseBasementLevelsRealBuiltSurfaces } from './getCaseBasementLevelsRealBuiltSurfaces';

export const getCaseBasementLevelsRealBuiltSurface = (
  caseGranulometry: CaseGranulometry
): Surface => Surface.sum(getCaseBasementLevelsRealBuiltSurfaces(caseGranulometry));
